module.exports = __webpack_public_path__ + "e7c6836fd4606acc0e401e56ed620d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/switch.png
// module id = 742
// module chunks = 0